export default "__VITE_ASSET__BsGzxp4___"